import { CoveragesCustomization } from "@covertree/new-business-policy-customization";

import {
  selectIsRecalculating,
  selectIsViewOnly,
  useEndorsementSelector,
} from "@redux/slices/endorsement";

import { SectionCard } from "../../SectionCard";
import { usePersonalizedPlan } from "./usePersonalizedPlan";

export function PersonalizedPlanSection() {
  const isViewOnly = useEndorsementSelector(selectIsViewOnly);
  const isRecalculating = useEndorsementSelector(selectIsRecalculating);
  const { coverages, rules } = usePersonalizedPlan();

  return (
    <SectionCard
      title="Personalized plan"
      dataTestId="personalized-plan-section">
      {coverages.length > 0 && (
        <CoveragesCustomization
          coverages={coverages}
          rules={rules}
          loading={isViewOnly || isRecalculating}
        />
      )}
    </SectionCard>
  );
}
